/* eslint react-hooks/exhaustive-deps: "warn" */

import { Button } from 'ui/atoms/Button/Button';
import { Icon } from 'ui/atoms/Icon/Icon';
import { Section } from 'ui/molecules/Section/Section';

import styles from './CrmAppRows.module.scss';

import type { CrmAppRowsProps } from './CrmAppRows.types';

export const CrmAppRows = ({ eyebrow, title, description, apps }: CrmAppRowsProps) => (
  <Section
    id="integrations"
    align="left"
    title={title}
    description={description}
    extra={eyebrow}
    introBlockClassName={styles.intro}
  >
    <div className={styles.rows}>
      {apps.map((app) => (
        <div key={app.key} className={styles.row}>
          <div className={styles.logoWrap}>
            <Icon type={app.iconType} className={styles.logo} />
          </div>

          <p className={styles.body}>{app.body}</p>

          <div className={styles.cta}>
            <Button
              type="blue"
              size="lg"
              href={app.cta.href}
              target={app.cta.external ? '_blank' : undefined}
              suffix={<Icon type="arrow-14" />}
            >
              {app.cta.label}
            </Button>
          </div>
        </div>
      ))}
    </div>
  </Section>
);
